import { render } from "./widget-indicator-trouble.vue?vue&type=template&id=53a4225e&ts=true"
import script from "./widget-indicator-trouble.ts?vue&type=script&lang=ts"
export * from "./widget-indicator-trouble.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__